import { useMount } from 'react-use';
import { useAppDispatch } from 'redux/hooks';
import {
  fetchActiveIntegrations,
  fetchIntegrationHealth,
  fetchIntegrationAgentDomains,
} from 'thunk';
import * as IntegrationTypes from 'IntegrationModule/types';
import { AVAILABLE_INTEGRATION_SERVICES, integrationHealthIsoStateIds } from '@constants';
import { formatIntegrationHealthDateParams } from 'utils';
import { integrationHealthIsoStateModifiers } from 'IntegrationModule/utils';
import { useIsSandboxCreationDisabled } from 'SandboxModule/hooks/useIsSandboxCreationDisabled';
import { useTenants } from 'TenantModule/hooks/useTenants';
import { useFeatureFlags } from 'hooks/useFeatureFlags';
import { useSyncGrowthBookAttributes } from 'hooks/useSyncGrowthBookAttributes';

const useAppOnMount = () => {
  const dispatch = useAppDispatch();

  useSyncGrowthBookAttributes();

  // Fetch tenants on mount
  useTenants({ isOff: false });

  const isSandboxCreationDisabled = useIsSandboxCreationDisabled();
  const { shouldEnableIntegrationServerConnection } = useFeatureFlags();

  useMount(() => {
    // fetch active counts and integraiton health

    // Spec: Hide integration side bar and prevent fetch to integration servers
    if (shouldEnableIntegrationServerConnection) {
      dispatch(fetchActiveIntegrations());
      dispatch(
        fetchIntegrationAgentDomains({
          onSuccess: ({
            response,
          }: {
            response: IntegrationTypes.FetchIntegrationAgentDomainsResponse;
          }) => {
            const targetServiceToFetch = response.data
              .map((targetService) => {
                return targetService.service;
              })
              .filter((service) => service !== 'live-test-server');
            targetServiceToFetch.forEach((targetService) => {
              dispatch(
                fetchIntegrationHealth({
                  targetService,
                  serviceNames: [targetService],
                  startDate: formatIntegrationHealthDateParams(new Date()),
                  endDate: formatIntegrationHealthDateParams(new Date()),
                  isoStateId: integrationHealthIsoStateIds.IntegrationCard,
                  modifier:
                    integrationHealthIsoStateModifiers[
                      integrationHealthIsoStateIds.IntegrationCard
                    ],
                }),
              );
            });
          },
        }),
      );
    }
  });

  return {
    isSandboxCreationDisabled,
  };
};

export default useAppOnMount;
